export default [
    {
        path: '/contents',
        name: 'contents',
        component: () =>
            import(
                /* webpackChunkName: "contents" */ '@/views/contents/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Conteúdos', to: { name: 'contents' }, disable: true },
            ],
            whitelabel: true,
        },
    },
    {
        path: '/contents/create',
        name: 'contents/create',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "contents" */ '@/views/contents/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Conteúdos', to: { name: 'contents' }, disable: false },
                {
                    text: 'Novo',
                    to: { name: 'contents/create' },
                    disable: true,
                },
            ],
            whitelabel: true,
        },
    },
    {
        path: '/contents/edit/:id',
        name: 'contents/edit',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "contents" */ '@/views/contents/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Conteúdos', to: { name: 'contents' }, disable: false },
                {
                    text: 'Editar',
                    to: { name: 'contents/edit' },
                    disable: true,
                },
            ],
            whitelabel: true,
        },
        props: true,
    },
]
